import {EmployeeSchedule} from './schedule.model';
import * as moment from 'moment';
import {WeeklyWorkShiftComponent} from '../home/schedule/WeeklyWorkShiftComponent';
import {WeeklyWorkShift} from "../home/schedule/model/WeeklyWorkShift";
import {ErrorFromWorkshift} from "../home/schedule/model/ErrorFromWorkShift";
import {CustomScheduleComponentManager} from "../home/schedulePerEmployee/common/CustomScheduleComponentManager";

export class WeeklyWorkshiftComponentManager extends CustomScheduleComponentManager<WeeklyWorkShiftComponent>{


  // private workShiftsByKey = new Map<string, WeeklyWorkShiftComponent[]>();
  // private ducon = new Array<WeeklyWorkShiftComponent>();

  public add( bean: WeeklyWorkShiftComponent) {


    if (!this.workShiftBySomeKey.get(bean.model.key)) {
      console.log('Creating array for key: ' + bean.model.key);
      this.workShiftBySomeKey.set(bean.model.key, new Array<WeeklyWorkShiftComponent>());
    }

    console.log('Adding key to array >' + bean.model.key + '<');
    this.workShiftBySomeKey.get(bean.model.key).push(bean);
    this.allComponents.push(bean);
    bean._manager = this;
  }
   /*
  public get(key: string): WeeklyWorkShiftComponent[] {
    console.log('getting >' + key + '<');
    const res = this.workShiftsByKey.get(key);
    if (!res) {
      console.log('returning empty array');
      return new Array<WeeklyWorkShiftComponent>();
    }
    return res;
  }
  */

  get keys(): string[] {
    return Array.from(this.workShiftBySomeKey.keys());
  }


  public clear() {
    this.workShiftBySomeKey.clear();
  }

  public getAllSorted(): WeeklyWorkShiftComponent[] {
    return this.allComponents.sort(
      (a: WeeklyWorkShiftComponent, b: WeeklyWorkShiftComponent) =>  {
        let resN = 0;
        if (a.model.jobAndUnitInfo.job.description > b.model.jobAndUnitInfo.job.description) {
          resN = 1;
        }
        if (a.model.jobAndUnitInfo.job.description < b.model.jobAndUnitInfo.job.description) {
          resN = -1;
        }
        if (resN === 0 ) {
          const ma = moment(a.model.startTime);
          const mb = moment(b.model.startTime);
          if (ma.unix() < mb.unix()) {
            return -1;
          }
          if (ma.unix() > mb.unix()) {
            return 1;
          }
        }
        return resN;
      });
  }

  // this.session.weeklyWorkshiftManager.hasSchedules(bean.employee.id, this.refDate, bean.startHour, bean.endHour, this.workShift);
  /**
   Find if an employee scheduled in (toExclude) is not already be scheduled for another time slot.
   */
  public hasSchedules(employeeId: string, refDate: Date, startHour: Date, endHour: Date, toExclude: WeeklyWorkShift): ErrorFromWorkshift[] {

    const res = new Array<ErrorFromWorkshift>();
    for (const bean of this.allComponents){
      if (bean.model !== toExclude) {
        const tmp = bean.model.hasSchedulesByEmployeeAndRefDate(employeeId, refDate, startHour, endHour);
        if (tmp) {
          if (tmp.length > 0) {
            const error = new ErrorFromWorkshift();
            error.weeklyWorkShift = bean.model;
            error.referringWorkShift = toExclude;
            error.schedules = new Array<EmployeeSchedule>();
            error.schedules.push(...tmp);
            bean.model.addError(error);
            toExclude.addError(error);
            res.push(error);
          }
        }
      } else {
        // console.log('SameBean Not checking...');
      }
    }
    return res;
  }

  public retrieveSchedulesForEmployeeNotInTheCurrentWeeklyWorkShift(employeeId: string, toExclude: WeeklyWorkShift): EmployeeSchedule[] {

    const res = new Array<EmployeeSchedule>();
    for (const bean of this.allComponents){
      if (bean.model !== toExclude) {
        res.push(...bean.model.retrieveSchedulesByEmployee(employeeId));
      } else {
        // console.log('SameBean Not checking...');
      }
    }
    return res;
  }

  //
  //
  // static sortByJobLabelAndStartHour(toSort: WeeklyWorkShift[]): WeeklyWorkShift[] {
  //   return toSort.sort(
  //     (a: WeeklyWorkShift, b: WeeklyWorkShift) =>  {
  //       let resN = 0;
  //       if (a.jobAndUnitInfo.job.description > b.jobAndUnitInfo.job.description) {
  //         resN = 1;
  //       }
  //       if (a.jobAndUnitInfo.job.description < b.jobAndUnitInfo.job.description) {
  //         resN = -1;
  //       }
  //       if (resN === 0 ) {
  //          const ma = moment(a.startTime);
  //          const mb = moment(b.startTime);
  //          if (ma.unix() < mb.unix()) {
  //            return -1;
  //          }
  //           if (ma.unix() > mb.unix()) {
  //             return 1;
  //           }
  //       }
  //       return resN;
  //   });
  // }

}
//
// export class ErrorFromWorkshiftManager {
//
//   private errorById = new Map<number, ErrorFromWorkshift>();
//
//
//   add( bean: ErrorFromWorkshift ) {
//     if (!this.errorById.get(bean.id)) {
//       this.errorById.set(bean.id, bean);
//     }
//   }
//
//   containsId (id: number): boolean {
//     if (this.errorById.get(id)) {
//       return true;
//     }
//     return false;
//   }
//
//   get( id: number): ErrorFromWorkshift {
//     return this.errorById.get(id);
//   }
//
// }
